var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('b-button',{staticClass:"m-r-15",attrs:{"variant":"success"},on:{"click":_vm.marcar_todo}},[_c('i',{staticClass:"icon-check"}),_vm._v(" Marcar todo como devuelto ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }